import EocVitalsV2 from "../../../../components/form_builder/elements/eoc_vitals/EocVitalsV2.vue";

export default {
  componentName: "fb-eoc-vitals-v2",
  component: EocVitalsV2,
  defaultAttrs: {
    properties: {
      value: ``,
      style: {},
      label: "Patient Vitals",
      description: "",
      hidePicker: false,
      hidden: false
    }
  },
  gridAttrs: {
    type: "template",
    hidden: true,
    template: ({ value }) => value
  },
  validate: () => {
    return [];
  }
};
